
/**
 * @returns a number between 0 and 1 representing the scroll progress of the element.
 */
export function findScrollProgressOfElement(element: HTMLElement): number {
  const childWidth = element.getBoundingClientRect().width;
  const currentScroll = element.scrollLeft;
  const maxScroll = element.scrollWidth - childWidth;

  // NOTE(emil): hack to fix spooky off by one pixel bug on desktop.
  const remainingScroll = maxScroll - currentScroll;
  if(remainingScroll <= 2) {
    return 1;
  }

  return element.scrollLeft / maxScroll;
}

export function scrollOneLeft(element: HTMLElement): void {
  element.scrollTo({
    behavior: 'smooth',
    left: element.scrollLeft - element.clientWidth,
  });
}

export function scrollOneRight(element: HTMLElement): void {
  element.scrollTo({
    behavior: 'smooth',
    left: element.scrollLeft + element.clientWidth,
  });
}
